import * as lv from './lv'
import * as en from './en'

const localize = {
  lv: { ...lv },
  en: { ...en },
}

export default localize
